export const getCircularNextIndex = (current, length, direction) => {
  if (direction === 'forward') {
    const newIndex = current + 1;

    // if overflow, back to zero
    return newIndex > length - 1 ? 0 : newIndex;
  }

  if (direction === 'backward') {
    const newIndex = current - 1;

    // if overflow of minimum, go to max
    return newIndex < 0 ? length - 1 : newIndex;
  }

  return current;
};
